import React, { Component, Fragment } from "react";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { SaqContext } from "../context/SaqContext";
import { useHistory } from "react-router-dom";
import { callApiDownloadSaqPdf } from "../services";
import DeleteSaqModal from "./DeleteSaqModal";

class SaqLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deletedId: null,
    };
  }

  onClickDeleteSaq = (saqId) => {
    this.setState(
      {
        deletedId: saqId,
      },
      () => {
        document.getElementById("btnOpenSaqDeleteConfirmationModal").click();
      }
    );
  };

  downloadSaqPdf = (saqId) => {
    callApiDownloadSaqPdf({ saqId: saqId })
      .then((res) => {
        //console.log("res", res);
        fetch(process.env.REACT_APP_API_URL + "/" + res.data).then(
          (response) => {
            response.blob().then((blob) => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              a.download = res.data;
              a.click();
            });
          }
        );
      })
      .catch((error) => {
        //console.log("Inside saq download... error", error);
      });
  };

  render() {
    const { type, saqData, history } = this.props;

    return (
      <div>
        <h2>
          {type === "draft" ? "SAQ Drafts" : "Previously Completed SAQ's"}{" "}
        </h2>
        <div className="card">
          <table className="table table-stipped table-bordered">
            <thead>
              <tr>
                <th>Website</th>
                <th>Saq Type</th>
                <th>Last Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {saqData && saqData.length > 0 ? (
                saqData.map((v, i) => {
                  return (
                    <tr key={uuidv4()}>
                      <td>{v.domain}</td>
                      <td>{v.type}</td>
                      <td>{moment(v.createdAt).format("MMMM Do YYYY")}</td>
                      <td>
                        <div className="dropdown">
                          <button
                            className="btn btn-primary btn-sm dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Actions
                          </button>
                          <div
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <button
                              className="dropdown-item"
                              onClick={() =>
                                history.push(
                                  "/saq-draft/" + v.type + "/" + v._id
                                )
                              }
                            >
                              Edit
                            </button>
                            {type === "completed" && (
                              <>
                                <button
                                  className="dropdown-item"
                                  onClick={() => {
                                    this.onClickDeleteSaq(v._id);
                                  }}
                                >
                                  Delete
                                </button>
                                <button
                                  className="dropdown-item"
                                  onClick={() => this.downloadSaqPdf(v._id)}
                                >
                                  Download PDF
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="3">No records.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <button
          id="btnOpenSaqDeleteConfirmationModal"
          className="btn d-none"
          data-toggle="modal"
          data-target="#saqDeleteConfirmationModal"
        >
          <label>Delete {this.state.deletedId}</label>
        </button>

        {type === "completed" && (
          <DeleteSaqModal deletedId={this.state.deletedId} />
        )}
      </div>
    );
  }
}

export default SaqLists;
